"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSessionId = void 0;
function generateSessionId() {
    return "s-" + Date.now() + "-" + Math.round(Math.random() * Math.pow(10, 10));
}
exports.generateSessionId = generateSessionId;
//# sourceMappingURL=generateSessionId.js.map